import { Injectable } from '@angular/core';

import { ApiService } from '../../../../../common/services/api.service';
import { environment } from 'src/environments/environment';
import { apiEndPoints } from '../../../../../common/constants/api-endpointsconstant';
import { ReportService } from 'src/app/reports/services/report.service';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class ReportHouseRentalService {

  constructor(
    private apiServive: ApiService,
    private reportService: ReportService
  ) { }

  averageRentUnitWisePayload: any = {
    pageSize: 20,
    pageNumber: 0,
    sort_order: null,
    year: null
  }

  getOverviewSummary() {
    let queryParams = { ...this.reportService.queryParams };
    if (queryParams?.year) {
      queryParams.year = this.reportService.yearMaxValue(queryParams.year);
    }
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    const url: string = `${environment.miUrl}${apiEndPoints.houseRentalOverview}${changeParams}`;
    return this.apiServive.get(url, false);
  }



  getAverageRentUnitWise(payload: any, year: any) {
    let queryParams = { ...this.reportService.queryParams };
    if (queryParams?.year) {
      queryParams.year = this.averageRentUnitWisePayload.year || this.reportService.yearMaxValue(queryParams.year);
    }
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    let offset = payload.pageNumber || 0
    let url: string = `${environment.miUrl}${apiEndPoints.houseRentalList}${changeParams}&limit=${payload?.pageSize}&offset=${offset}`;
    if (payload.sort_order) {
      url += `&sort_order=${payload.sort_order}`;
    }
    if(offset == 0){
      url += "&is_count=true"
    }
    this.averageRentUnitWisePayload.pageNumber = offset;
    return this.apiServive.get(url, false);
  }

  downloadTransactionReport(type: string, user_id: number) {
    let url: string = `${environment.miUrl}${apiEndPoints.downloadTransactionReport}${this.reportService.filterQueryParams}&type=${type}&user_id=${user_id}`;
    return this.apiServive.get(url);
  }

  downloadExcelUrl() {
    return `${environment.miUrl}${apiEndPoints.downloadExcel}`;
  }





  formatOverViewSummary(data: any) {

    data['totalhighest_rent'] = this.reportService.calcPercentage(data.prev_highest_rent, data.highest_rent);
    data['totalaverage_rent'] = this.reportService.calcPercentage(data.prev_avg_rent, data.avg_rent);
    data['untillDate'] = data.max_date ? moment.utc(data.max_date).local().format('DD MMM YYYY') : null;
    return data;
  }


  downloadHouseRentalReport(type:string, user_id:any){
    const url: string = `${environment.miUrl}${apiEndPoints.reportDownload}${this.reportService.filterQueryParams}&type=${type}&user_id=${user_id}`;
    return this.apiServive.get(url);
  }
  
}
